import React from 'react';
import { useLocation } from 'react-router-dom'
import { inject, observer } from 'mobx-react';
import DataGrid, { Column, Lookup } from 'devextreme-react/data-grid';
import { Template } from 'devextreme-react/core/template';
import { createStore } from 'devextreme-aspnet-data-nojquery';

import { trans } from '../../common/utils';
import apiUrls from '../../common/api/api-urls';
import { languages } from '../../configs/i18n';
import dataGridDefaultSettings from '../../components/datagrid-settings';
import PageSelector from '../../components/page-selector';

const LogLeoServicePage = ({
    store: {
        languages: { table },
    },
    setCurrentPage,
}) => {
    return (
        <DataGrid
            {...dataGridDefaultSettings({
                url: apiUrls.logs.service,
                key: 'logId',
                language: languages.languageId[table],
                toolbar: true,
                languagePicker: false,
                toolbarCenter: { template: 'pageName', location: 'center' },
                settingStorageName: 'BMA_grid_logs_service_USERID',
                editing: {
                    allowAdding: false,
                    allowUpdating: false,
                },
                columnFixing: { enabled: false },
            })}>
            <Column
                dataField={'logId'}
                caption={trans('LogID')}
                dataType={'number'}
                sortOrder={'asc'}
                showInColumnChooser={false}
                allowHiding={false}
                width={100}
            />
            <Column
                dataField={'logIdt'}
                caption={trans('LogIdt')}
                dataType={'datetime'}
                format={'dd.MM.yyyy HH:mm:ss'}
                width={180}
            />
            <Column
                dataField={'logActionId'}
                caption={trans('LogAction')}
                dataType={'number'}>
                width={120}
                <Lookup
                    dataSource={[
                        {
                            type: 1,
                            value: `1 - ${trans('Insert')}`,
                        },
                        { type: 2, value: `2 - ${trans('Update')}` },
                        { type: 3, value: `3 - ${trans('Delete')}` },
                    ]}
                    displayExpr={'value'}
                    valueExpr={'type'}
                />
            </Column>
            <Column
                dataField={'logUserId'}
                caption={trans('LogUser')}
                dataType={'number'}>
                width={120}
                <Lookup
                    dataSource={createStore({
                        key: 'key',
                        loadUrl: apiUrls.lookup.user,
                        onBeforeSend: (method, ajaxOptions) => {
                            ajaxOptions.data.languageid =
                                languages.languageId[table];
                            ajaxOptions.xhrFields = { withCredentials: true };
                        },
                    })}
                    displayExpr={'value'}
                    valueExpr={'key'}
                    allowClearing={true}
                />
            </Column>
            <Column
                dataField={'logSqlUserName'}
                caption={trans('Log Sql User Name')}
                dataType={'string'}
                width={120}
            />
            <Column
                dataField={'logSessionId'}
                caption={trans('Log Session ID')}
                dataType={'number'}
                width={100}
            />


            <Column
                dataField={'serviceId'}
                caption={trans('ID')}
                dataType={'number'}
                width={100}
            />

            <Column
                dataField={'paymentServiceProviderId'}
                caption={trans('Провайдер для оплаты')}
                dataType={'number'}
                width={120}
            >
                <Lookup
                    dataSource={createStore({
                        key: 'key',
                        loadUrl: apiUrls.lookup.serviceProvider,
                        onBeforeSend: (method, ajaxOptions) => {
                            //ajaxOptions.data.languageid = 1;
                            ajaxOptions.xhrFields = {
                                withCredentials: true,
                            };
                        },
                    })}
                    displayExpr={'value'}
                    valueExpr={'key'}
                />
            </Column>

            <Column
                dataField={'pid'}
                caption={trans('Родитель')}
                dataType={'number'}
                width={150}
            >
                <Lookup
                    dataSource={createStore({
                        key: 'key',
                        loadUrl: apiUrls.lookup.service,
                        onBeforeSend: (method, ajaxOptions) => {
                            //ajaxOptions.data.languageid = 1;
                            ajaxOptions.xhrFields = {
                                withCredentials: true,
                            };
                        },
                    })}
                    displayExpr={'value'}
                    valueExpr={'key'}
                    allowClearing={true}
                />
            </Column>

            <Column
                dataField={'name'}
                caption={trans('Название')}
                dataType={'string'}
                width={250}
            />

            <Column
                dataField={'terminalMinSum'}
                caption={trans('Макс сумма (терминал)')}
                dataType={'number'}
                width={150}
            />

            <Column
                dataField={'terminalMaxSum'}
                caption={trans('Мин сумма (терминал)')}
                dataType={'number'}
                width={150}
            />

            <Column
                dataField={'onlineMinSum'}
                caption={trans('Макс сумма (онлайн)')}
                dataType={'number'}
                width={150}
            />

            <Column
                dataField={'onlineMaxSum'}
                caption={trans('Мин сумма (онлайн)')}
                dataType={'number'}
                width={150}
            />

            <Column
                dataField={'sortOrder'}
                caption={trans('Сортировка')}
                dataType={'number'}
                width={120}
            />

            <Column
                dataField={'isFixedPrice'}
                caption={trans('Цена фиксированная?')}
                dataType={'boolean'}
                width={100}
            />

            <Column
                dataField={'websiteVisible'}
                caption={trans('На сайте?')}
                dataType={'boolean'}
                width={100}
            />

            <Column
                dataField={'website2Visible'}
                caption={trans('На сайте 2?')}
                dataType={'boolean'}
                width={100}
            />

            <Column
                dataField={'accountRegex'}
                caption={trans('Regex аккаунта')}
                dataType={'string'}
                width={150}
            />

            <Column
                dataField={'accountText'}
                caption={trans('Текст аккаунта')}
                dataType={'string'}
                width={150}
            />

            <Column
                caption={''}
                width={50}
                visible={true}
            />

            <Template
                name={'pageName'}
                render={() => (
                    <PageSelector
                        setCurrentPage={(comp) => setCurrentPage(comp)}
                    />
                )}
            />
        </DataGrid>
    );
};

export default inject('store')(observer(LogLeoServicePage));
